export default __webpack_public_path__ + "static/sneakers2.inspirations-35f8f6d4af86bdae5c9def40b3dad978.jpg";